import { render, staticRenderFns } from "./AvatarProfile.vue?vue&type=template&id=b94509ca&scoped=true&"
import script from "./AvatarProfile.vue?vue&type=script&lang=js&"
export * from "./AvatarProfile.vue?vue&type=script&lang=js&"
import style0 from "./AvatarProfile.vue?vue&type=style&index=0&id=b94509ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94509ca",
  null
  
)

export default component.exports